import React from "react";
import tickMark from "../Assests/tickmarkstep5.svg";

const ProgressBar = ({ steps, currentStep }) => {
  return (
    <div style={styles.progressBar}>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          {/* Progress bar segment */}
          <div
            style={{
              ...styles.progressBarSegment,
              ...(step < currentStep && styles.completedSegment), // Completed segments
              ...(step === currentStep && (currentStep === 5 ? styles.completedSegment : styles.inProgressSegment)),
            }}
          >
            <div
              style={{
                ...styles.progressBarFill,
                ...(step < currentStep && styles.completedFill), // Fill for completed segments
              }}
            />
          </div>

          {/* Progress state (circle with number and status) */}
          <div
            style={{
              ...styles.progressState,
              ...(step < currentStep && styles.completedState), // Completed steps
              ...(step === currentStep && (currentStep === 5 ? styles.completedState : styles.inProgressState)),
            }}
          >
            {index === 4 ? (
              <img src={tickMark} alt="✓" style={styles.tickMark} />
            ) : (
              <div style={styles.stepNumber}>{index + 1}</div>
            )}

            {/* Success indicator for completed steps */}
            {step < currentStep && <div style={styles.success} />}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

// Inline CSS styles
const styles = {
  progressBar: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  progressBarSegment: {
    flex: 1,
    height: "0.6vh",
    backgroundColor: "rgba(255, 255, 255, 0.08)", // Default color for incomplete segments
    position: "relative",
    borderRadius: "0.5vh",
  },
  completedSegment: {
    background: "linear-gradient(180deg, rgba(30, 215, 96, 0.20) -0.12%, rgba(30, 215, 96, 0.40) 100.12%), linear-gradient(0deg, rgba(30, 215, 96, 0.19) 0.12%, rgba(30, 215, 96, 0.40) 99.88%)", // Green gradient for completed segments
  },
  inProgressSegment: {
    background: "linear-gradient(180deg, rgba(72, 205, 255, 0.20) -0.12%, rgba(72, 205, 255, 0.40) 100.12%), linear-gradient(0deg, rgba(72, 205, 255, 0.19) 0.12%, rgba(72, 205, 255, 0.40) 99.88%)",
  },
  progressBarFill: {
    height: "100%",
    width: "0",
    transition: "width 0.3s ease",
  },
  completedFill: {
    width: "100%",
  },
  progressState: {
    width: "2vw",
    height: "2vw",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 255, 255, 0.08)", // Default color for incomplete steps
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    margin: "0 0.5vw", // Spacing between steps
  },
  completedState: {
    background: "linear-gradient(180deg, rgba(30, 215, 96, 0.20) -0.12%, rgba(30, 215, 96, 0.40) 100.12%), linear-gradient(0deg, rgba(30, 215, 96, 0.19) 0.12%, rgba(30, 215, 96, 0.40) 99.88%)",
  },
  inProgressState: {
    background: "linear-gradient(180deg, rgba(72, 205, 255, 0.20) -0.12%, rgba(72, 205, 255, 0.40) 100.12%), linear-gradient(0deg, rgba(72, 205, 255, 0.19) 0.12%, rgba(72, 205, 255, 0.40) 99.88%)",
  },
  success: {
    width: "0.8vw",
    height: "0.8vw",
    borderRadius: "50%",
    position: "absolute",
  },
  stepNumber: {
    fontSize: "1.0vw",
    fontWeight: "bold",
    color: "#FFF",
    zIndex: 1, // Ensure the number is above the success indicator
  },
  tickMark: {
    width: "1.0vw",
    zIndex: 1,
  },
};

export default ProgressBar;